import React, { useState, useEffect } from 'react';
import { Modal, Button, FormInput, FormSelect, RichTextEditor } from '../../../components/ui';

const CATEGORY_OPTIONS = [
  // { label: 'Initial Quote', value: 'Initial Quote' },
  // { label: 'Final Quote', value: 'Final Quote' },
  // { label: 'Appliances', value: 'Appliances' },
  { label: 'Estimations', value: 'Estimations' },
  { label: 'Sale Invoice', value: 'Sale Invoice' },
  { label: 'Others', value: 'Others' }
];

export default function AddTermInfoModal({ isOpen, onClose, onSave, initialData, isViewOnly }) {
  const [formData, setFormData] = useState({
    title: '',
    categorySelect: 'Estimations',
    categoryCustom: '',
    description: '',
    paymentTitle: 'PAYMENT DETAILS',
    paymentDescription: '',
    status: 'Active',
    isRelatedToAppliances: false
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialData) {
      const initialCat = (initialData.isRelatedToAppliances && (!initialData.category || initialData.category === 'General' || initialData.category === 'Initial Quote'))
        ? 'Appliances'
        : (initialData.category === 'General' || !initialData.category ? 'Estimations' : initialData.category);
      const isPredefined = CATEGORY_OPTIONS.some(opt => opt.value === initialCat && opt.value !== 'Others');

      setFormData({
        title: initialData.title || '',
        categorySelect: isPredefined ? initialCat : 'Others',
        categoryCustom: isPredefined ? '' : initialCat,
        description: initialData.description || '',
        paymentTitle: initialData.paymentTitle || 'PAYMENT DETAILS',
        paymentDescription: initialData.paymentDescription || '',
        status: initialData.status || 'Active',
        isRelatedToAppliances: initialData.isRelatedToAppliances || false
      });
    } else {
      setFormData({
        title: '',
        categorySelect: 'Estimations',
        categoryCustom: '',
        description: '',
        paymentTitle: 'PAYMENT DETAILS',
        paymentDescription: '',
        status: 'Active',
        isRelatedToAppliances: false
      });
    }
  }, [initialData, isOpen]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleRichTextChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isViewOnly) {
      onClose();
      return;
    }
    setLoading(true);
    try {
      /* Developer : Nithin - Date : 21-07-2026 - Save category options cleanly and maintain full backwards compatibility */
      const finalCategory = formData.categorySelect === 'Others'
        ? (formData.categoryCustom.trim() || 'Estimations')
        : formData.categorySelect;

      const dataToSave = {
        title: formData.title || 'TERMS AND CONDITIONS',
        paymentTitle: formData.paymentTitle || 'PAYMENT DETAILS',
        category: finalCategory,
        description: formData.description,
        paymentDescription: formData.paymentDescription,
        status: formData.status,
        isRelatedToAppliances: finalCategory === 'Appliances' || formData.isRelatedToAppliances
      };
      await onSave(dataToSave);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={isViewOnly ? "VIEW TERMS AND CONDITIONS" : initialData ? "EDIT TERMS AND CONDITIONS" : "ADD TERMS AND CONDITIONS"}
      size="2xl"
    >
      <form onSubmit={handleSubmit} className="flex flex-col">
        <div className="space-y-6 pb-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <FormSelect
              label="Category"
              name="categorySelect"
              value={formData.categorySelect}
              onChange={handleChange}
              options={CATEGORY_OPTIONS}
              disabled={isViewOnly}
            />
            {formData.categorySelect === 'Others' && (
              <FormInput
                label="Specify Category Name"
                name="categoryCustom"
                value={formData.categoryCustom}
                onChange={handleChange}
                placeholder="Enter custom category name..."
                disabled={isViewOnly}
              />
            )}
          </div>

          <RichTextEditor
            label="TERMS AND CONDITIONS"
            name="description"
            value={formData.description}
            onChange={(value) => handleRichTextChange('description', value)}
            placeholder="Enter term points here (e.g. 1. ...)"
            disabled={isViewOnly}
            minHeight="160px"
          />

          <RichTextEditor
            label="PAYMENT TERMS"
            name="paymentDescription"
            value={formData.paymentDescription}
            onChange={(value) => handleRichTextChange('paymentDescription', value)}
            placeholder="Enter payment points here (e.g. 1. ...)"
            disabled={isViewOnly}
            minHeight="160px"
          />
        </div>

        <div className="flex items-center justify-end gap-3 pt-4 border-t border-slate-100 mt-2 shrink-0 bg-white">
          <Button type="button" variant="secondary" onClick={onClose}>
            {isViewOnly ? "Close" : "Cancel"}
          </Button>
          {!isViewOnly && (
            <Button type="submit" loading={loading} variant="primary">
              {initialData ? "Update" : "Save"}
            </Button>
          )}
        </div>
      </form>
    </Modal>
  );
}




